import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { toast } from 'react-toastify';
import { typesRegulations, updateStatus } from '../../../helpers/adipiBackendUrl';
import { getTable, patchApiCall, postApiCall } from "../../../services/mainServices";
import {
  ADD_NEW_TYPESREGULATION,
  DELETE_TYPESREGULATION,
  GET_TYPESREGULATIONS,
  UPDATE_TYPESREGULATION,
  UPDATE_TYPESREGULATION_STATUS
} from "./actionTypes";
import {
  addTypesRegulationFail,
  addTypesRegulationSuccess,
  deleteTypesRegulationFail,
  deleteTypesRegulationSuccess,
  getTypesRegulationsFail,
  getTypesRegulationsSuccess,
  setState,
  updateTypesRegulationFail,
  updateTypesRegulationSuccess,
} from "./actions";
//Include Both Helper File with needed methods

function* fetchTypesRegulations( { payload: { params } } ) {
  try {
    yield put(setState(true))
    console.log('Types Regulations:', typesRegulations)
    const response = yield call(getTable,typesRegulations, params.toString());
    yield put(setState(false))
    yield put(getTypesRegulationsSuccess(response.items,response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false))
    yield put(getTypesRegulationsFail(error));
  }
}

function* updateTypesRegulation ({payload: typesRegulationObj }) {
  try {
    const { id, ...rest } = typesRegulationObj;
    yield call(patchApiCall,`${typesRegulations}/${id}`, rest);
    const response = yield call(getTable,`${typesRegulations}/${typesRegulationObj.id}`);
    yield put(updateTypesRegulationSuccess(response));
    toast.success('Registro actualizado correctamente')

  } catch (error) {
    yield put(updateTypesRegulationFail(error));
    toast.error('Error al actualizar el registro')
  }
}

function* updateTypesRegulationStatus ({payload: typesRegulationObj }) {
  try {
    const { id } = typesRegulationObj;
    yield call(patchApiCall,`${typesRegulations}/${updateStatus}/${id}`, { recordStatus: typesRegulationObj.recordStatus });
    const response = yield call(getTable,`${typesRegulations}/${typesRegulationObj.id}`);
    yield put(updateTypesRegulationSuccess(response));
  } catch (error) {
    yield put(updateTypesRegulationFail(error));
  }
}

function* deleteTypesRegulation ({payload: typesRegulationObj}) {
  try {
    yield put(deleteTypesRegulationSuccess(typesRegulationObj.id));
    toast.success('Registro borrado correctamente')

  } catch (error) {
    yield put(deleteTypesRegulationFail(error));
    toast.error('Error al borrar el registro')

  }
}

function* postingTypesRegulation ({ payload: typesRegulation}) {
  try {
    const response = yield call(postApiCall, typesRegulations ,typesRegulation);
    yield put(addTypesRegulationSuccess(response));
    toast.success('Registro agregado correctamente')

  } catch (error) {
    yield put(addTypesRegulationFail(error));
    toast.error('Error al agregar el registro')

  }
}

function* typesRegulationsSaga() {
  yield takeEvery(GET_TYPESREGULATIONS, fetchTypesRegulations);
  yield takeEvery(ADD_NEW_TYPESREGULATION, postingTypesRegulation);
  yield takeEvery(UPDATE_TYPESREGULATION, updateTypesRegulation);
  yield takeEvery(UPDATE_TYPESREGULATION_STATUS, updateTypesRegulationStatus);
  yield takeEvery(DELETE_TYPESREGULATION, deleteTypesRegulation);
}

export default typesRegulationsSaga;
